import { useHandleTransactionRequest } from "./useHandleTransactionRequest";

/**
 * AssetId in the Hydrozoa API JSON format.
 * - Ada: `{ tag: "Ada" }`
 * - NativeToken: `{ tag: "NativeToken", policyId: "<56-char hex>", assetName: "<hex>" }`
 */
type ApiAssetId =
  | { tag: "Ada" }
  | { tag: "NativeToken"; policyId: string; assetName: string };

type ApiTradingPair = {
  base: ApiAssetId;
  quote: ApiAssetId;
};

type PlaceOrderPayload = {
  tradingPair: ApiTradingPair;
  side: "Bid" | "Ask";
  /** Decimal string, e.g. "1.5" or "1000000.123456" */
  price: string;
  /** Raw quantity in smallest unit (u64) */
  quantity: number;
  destination: null;
};

export const useHandlePlaceOrderRequest = () => {
  return useHandleTransactionRequest<PlaceOrderPayload>("PlaceOrder");
};
